(function () {
    "use strict";

    /**
     * Utility functions to read and write to a cookie. Intended to be bundled with the tracking code
     * Created by maktarh on 23/03/2017.
     * @constructor
     */
    function Cookie() {
    }

    /**
     * Returns the value of a cookie
     * @param name - name of the cookie
     * @returns {*}
     */
    Cookie.prototype.get = function (name) {
        var cookies = "; " + document.cookie;
        var values = cookies.split("; " + name + "=");
        return values.length === 2 ? values.pop().split(";").shift() : "";
    };

    /**
     * Writes a value to a named cookie
     * @param name
     * @param value
     * @param days
     */
    Cookie.prototype.set = function (name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    };

    window.nadex = window.nadex || {};
    window.nadex.marketing = window.nadex.marketing || {};
    window.nadex.marketing.analytics = window.nadex.marketing.analytics || {};
    window.nadex.marketing.analytics.cookie = new Cookie();

}());